// ============================================
// TRAVMISSIONS — YOUR CONTENT LIVES HERE
// ============================================
//
// To add a new transmission:
//   1. Copy one of the blocks below
//   2. Paste it at the TOP of the array
//   3. Update the id (increment the number)
//   4. Move "latest: true" to your new entry
//   5. Save and redeploy
//
// Types: "music", "poem", "thought"
//   music with audio file → include audioSrc
//   music on Spotify → include spotifyId
//   poem/thought → include excerpt
//
// ============================================

const TRANSMISSIONS = [
  {
    id: "TX-002",
    type: "music",
    title: "Hypnagogia",
    year: "2026",
    audioSrc: "/hypnagogia.mp3",
    latest: true,
  },
  {
    id: "TX-001",
    type: "music",
    title: "Pacing for Eternity",
    year: "2026",
    audioSrc: "/pacing-for-eternity.mp3",
  },
];

export default TRANSMISSIONS;